import React from 'react'
import {
  List,
  DatagridConfigurable,
  TextField,
  ShowButton,
  FilterButton,
  ExportButton,
  DateField,
} from 'react-admin';
import NestedReferenceField from '../../components/NestedReferenceField';

const TeamList = (props) => {
  const actions = (
    <>
      <FilterButton />
      <ExportButton />
    </>
  );

  return (
    <List {...props} perPage={50} sort={{ field: 'id', order: 'DESC' }} actions={actions}>
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <TextField source="name" />
        <NestedReferenceField source="organisation" labelField="name" resource="organisations" label="Organisation" />
        <TextField source="confidentiality_policy" label="Confidentiality" />
        <DateField source="creation_date" label="Created at" showTime />
        <ShowButton />
      </DatagridConfigurable>
    </List>
  );
};

export default TeamList;
